<template>
    <el-dialog
        :visible="show"
        :title="$t('TABLE_HEADER_Message')"
        top="10vh"
        width="45%"
        :close-on-click-modal="false"
        append-to-body
        @close="onDialogClose">
        <div class="sas-comments-container">
            <div class="message-board">
                <div
                    v-for="(v, k) in list"
                    :key="k"
                    :class="['message-row', v.sendUserType == getUser.userType ? 'message-row-float-right' : 'message-row-float-left']">
                    <div class="message-icon">
                        <el-avatar size="small" :src="circleUrl"></el-avatar>
                    </div>
                    <div class="message-msg">
                        <div class="username">{{ v.sendUserName }} 【{{ v.createDate | formatDateTime }}】</div>
                        <div class="message-text">
                            <el-popconfirm v-if="v.sendUserId === getUser.userId" :title="$t('msg_delete_sure')" @confirm="deleteMessage(v)">
                                <i slot="reference" class="el-icon-delete deleteButton leftButton"></i>
                            </el-popconfirm>
                            {{ v.message }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="input-board">
                <el-input
                    type="textarea"
                    resize="none"
                    maxlength="300"
                    show-word-limit
                    :rows="3"
                    :placeholder="$t('ENTER_MESSAGE_CONTENT')"
                    @keyup.enter.exact.native="onMessageSendClick"
                    v-model="send.value">
                </el-input>
                <i :title="$t('comment_send')" class="el-icon-s-promotion wl-icon-send" @click="onMessageSendClick"></i>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import API from '@/api'
import { mapGetters } from 'vuex'

export default {
    name: 'SASComments',
    data() {return {
        list: [],
        send: {
            loading: false,
            value: ''
        },
        circleUrl: require('@/assets/img/messageboard1.png')
    }},
    props: {
        show: {
            type: Boolean,
            default: false
        },
        statuId: {
            type: String,
            default: ''
        },
        reloadParents: {
            type: Function,
            default: () => {}
        },
        siteId: {
            type: String,
            default: ''
        },
    },
    mounted() {
        this.getList()
    },
    methods: {
        deleteMessage(v) {
            API.status.deleteStatutoryMessage({
                ids: [v.id]
            }).then(res => {
                if (res.code == '1') {
                    this.$message.success(this.$t('msg_success'))
                    this.getList()
                } else {
                    this.$message.error(this.$t(res.code))
                }
            }).catch(e => {
                console.error(e);
                this.$message.error(this.$t('SYS_USER_003'))
            }).finally(() => {})
        },
        getList() {
            API.status.getStatutoryMessage({
                statutoryId: this.statuId
            }).then(res => {
                if (res.code == '1') {
                    this.list = res.data.reverse()
                } else {
                    this.$message.error(this.$t(res.code))
                }
            }).catch(e => {
                console.error(e);
                this.$message.error(this.$t('SYS_USER_003'))
            }).finally(() => {
                this.scrollToBottom()
            })

        },
        onDialogClose() {
            this.reloadParents()
            this.$emit('update:show', false)
        },
        onMessageSendClick() {
            if (this.send.loading) return
            const value = this.send.value
            this.send.value = ''
            if (value == "\n" || value == '') {
                this.$message.error(this.$t('MESSAGE_ERROR01'))
                return
            }
            this.send.loading = true
            API.status.postStatutoryMessage({
                clientStatutoryMessages: [{ statutoryId: this.statuId, message: value, siteId: this.siteId }]
            }).then(res => {
                if (res.code == '1') {
                    this.$message.success(this.$t('msg_success'))
                } else {
                    this.$message.error(this.$t(res.code))
                }
            }).catch(e => {
                console.error(e);
                this.$message.error(this.$t('SYS_USER_003'))
            }).finally(() => {
                this.send.value = ''
                this.send.loading = false
                this.getList()
            })
        },
        scrollToBottom() {
            const ele = document.getElementsByClassName('message-board')[0]
            const timer = setTimeout(function() {
                if (ele.scrollHeight > ele.clientHeight) {
                    //设置滚动条到最底部
                    ele.scrollTop = ele.scrollHeight
                }
                ele.style.opacity = 1
                this.loading = false
                if (timer) {
                    clearTimeout(timer)
                }
            }, 100)
        }
    },
    computed: {
        ...mapGetters('common', {
            getSite: 'getSite',
            getUser: 'getUser',
            getEntityIds: 'getEntityIds'
        })
    }
}
</script>
<style scoped>
.sas-comments-container {
    width: 100%;
    height: 50vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: #f9f9f9;
    border: solid 1px #e9e9eb;
    border-radius: 5px;
}
.sas-comments-container .message-board {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    padding-bottom: 50px;
}

.sas-comments-container .message-board .message-row {
    display: flex;
    align-items: center;
    margin-top: 20px;
}
.sas-comments-container .message-board .message-row-float-left {
    flex-direction: row;
}
.sas-comments-container .message-board .message-row-float-right {
    flex-direction: row-reverse;
}

.sas-comments-container .message-board .message-row-float-left .message-icon {
    margin-left: 10px;
    margin-right: 20px;
}
.sas-comments-container .message-board .message-row-float-right .message-icon {
    margin-left: 20px;
    margin-right: 10px;
}
.sas-comments-container .message-board .message-row .message-msg {
    display: flex;
    flex-direction: column;
    max-width: 80%;
}

.sas-comments-container .message-board .message-row .message-msg .username {
    line-height: 20px;
}
.sas-comments-container .message-board .message-row .message-msg .message-text {
    padding: 8px 5px;
    line-height: 25px;
    border-radius: 5px;
    text-align: left;
    position: relative;
}
.sas-comments-container .message-board .message-row-float-left .message-msg .message-text {
    background-color: #a8c8e7;
}
.sas-comments-container .message-board .message-row-float-right .message-msg .message-text {
    background-color: white;
    border: solid 1px black;
}

.deleteButton {
    position: absolute;
    top: calc(50% - 7px);
    cursor: pointer;
    color: #dd6161;
    left: -20px;
}
.input-board {
    border: #e9e9eb 1PX solid;
    border-radius: 0 0 5px 5px;
    position: relative;
    padding-bottom: 36px;
    background-color: white;
}

.input-board ::v-deep .el-textarea__inner {
    border: none;
    font-size: 13PX;
}

.input-board ::v-deep .el-textarea__inner:hover {
    border: none;
}
.wl-icon-send {
    font-size: 20px;
    line-height: 26px;
    padding: 0 3px;
    background-color: #409EFF;
    color: #ffffff;
    border-radius: 13px;
    border: #409EFF 1PX solid;
    cursor: pointer;
    position: absolute;
    bottom: 10px;
    right: 10px;
}
::v-deep .textarea__inner  {
    font-size: 14PX;
}
</style>